import NoticeCenterView from './NoticeCenterView'
export default NoticeCenterView;